import React from "react";
import styles from './ProductCard.module.css';
import * as Funciones from '../../utils/funciones';
import * as Constantes from "../../utils/constantes";

const ProductCard = ({ producto, tipoCambio }) => {
    return (
        <React.Fragment>
            <div className={styles.productCard}>
                <div className={styles.productCard__top}>
                    <h3>{producto.descripcion}</h3>
                    <div className={styles.codigo_sbs}><b>Código SBS:&nbsp;</b> {producto.codigoRegistroSbs}</div>
                    <h4>Coberturas y beneficios</h4>
                    <ul>
                        {producto.coberturas && producto.coberturas.length > 0 && producto.coberturas.sort(function (a, b) {
                            return b.esCoberturaPrincipal - a.esCoberturaPrincipal
                        }).map((item, index) => {
                            return <li key={index}>
                                <div>{item.descripcion}:</div>
                                <div>{Funciones.mostrarFormatoMoneda(item.monto, producto.moneda.codigo)}</div>
                            </li>;
                        })}
                    </ul>
                </div>
                <hr />
                <div className={styles.productCard__bottom}>
                    <h3>Detalle de prima</h3>
                    <ul>
                        <li>
                            <div>Prima comercial:</div>
                            <div>{Funciones.mostrarFormatoMoneda(producto.primaComercial, producto.moneda.codigo)}</div>
                        </li>
                        {producto.codigoTipoProducto !== Constantes.COD_TIPO_PRODUCTO_VIDA_TEMPORAL &&
                            producto.codigoTipoProducto !== Constantes.COD_TIPO_PRODUCTO_ACCIDENTES_PERSONALES &&
                            producto.codigoTipoProducto !== Constantes.COD_TIPO_PRODUCTO_VIDA_DEVOLUCION
                            ? <li>
                                <div>Prima de excedentes:</div>
                                <div>{Funciones.mostrarFormatoMoneda(producto.primaExcedente, producto.moneda.codigo, true)}</div>
                            </li>
                            : null
                        }
                        <li>
                            <div>I.G.V. (18%)</div>
                            <div>{Funciones.mostrarFormatoMoneda(producto.igv, producto.moneda.codigo, true)}</div>
                        </li>
                    </ul>

                    <div className={styles.productCard__total}>
                        <div>
                            <div>Total {producto.frecuenciaPago.descripcion}</div>
                            <div>{Funciones.mostrarFormatoMoneda(producto.primaTotal, producto.moneda.codigo)}</div>
                        </div>
                        {Constantes.COD_MONEDA_DOLARES === producto.moneda.codigo
                            ? <div>
                                <div>Total {producto.frecuenciaPago.descripcion} Soles</div>
                                <div>S/ {Funciones.mostrarFormatoMoneda(
                                    Funciones.transformarMonto(producto.primaTotal, producto.moneda.codigo,
                                        Constantes.COD_MONEDA_SOLES, tipoCambio)
                                )}</div>
                            </div>
                            : null
                        }
                        <div>
                            <div>TCEA (%)</div>
                            <div>{Funciones.mostrarFormatoMoneda(producto.tcea, undefined, true)} %</div>
                        </div>
                        <div>
                            <div>Interés por fraccionamiento</div>
                            <div>{Funciones.mostrarFormatoMoneda(producto.interesTcea, producto.moneda.codigo, true)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default ProductCard;